import { AUDIT_MODELS_API_URL, LATEST_AUDIT_MODELS_SEARCH_AVAILABLE_URL, LATEST_AUDIT_MODELS_SEARCH_MY_AUDIT_MODELS_URL } from 'constants/ApiConstants';
import { AUDIT_MODEL_STATUS } from 'modules/auditModels/constants';

import * as types from '../actionTypes';

/**
 * @param {string} auditModelId
 * @param {import('@arhs-fleetback/types/entities/audits').AuditModelsStatus} status
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').PatchAuditModelStatusAction}
 */
export const patchAuditModelStatus = (auditModelId, status, meta = {}) => ({
  type: types.PATCH_AUDIT_MODEL_STATUS,
  payload: {
    request: {
      method: 'PATCH',
      url: `${AUDIT_MODELS_API_URL}/${auditModelId}/status`,
      data: {
        status,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/auditModels/types').AuditModel} auditModel
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').PatchAuditModelStatusSuccessAction}
 */
export const patchAuditModelStatusSuccess = (auditModel, meta = {}) => ({
  type: types.PATCH_AUDIT_MODEL_STATUS_SUCCESS,
  payload: auditModel,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').PatchAuditModelStatusFailureAction}
 */
export const patchAuditModelStatusFailure = (error, meta = {}) => ({
  type: types.PATCH_AUDIT_MODEL_STATUS_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {Object} params
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsMyAction}
 */
export const fetchAuditModelsMy = (params, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_MY,
  payload: {
    request: {
      method: 'GET',
      url: LATEST_AUDIT_MODELS_SEARCH_MY_AUDIT_MODELS_URL,
      params: {
        projection: 'page',
        status: [AUDIT_MODEL_STATUS.OPEN, AUDIT_MODEL_STATUS.DRAFT],
        ...params,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/global/generic.types').PageContent<import('modules/auditModels/types').AuditModel>} auditModels
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsMySuccessAction}
 */
export const fetchAuditModelsMySuccess = (auditModels, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_MY_SUCCESS,
  payload: auditModels,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsMyFailureAction}
 */
export const fetchAuditModelsMyFailure = (error, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_MY_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {Object} params
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsAvailableAction}
 */
export const fetchAuditModelsAvailable = (params, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_AVAILABLE,
  payload: {
    request: {
      method: 'GET',
      url: LATEST_AUDIT_MODELS_SEARCH_AVAILABLE_URL,
      params: {
        projection: 'page',
        status: [AUDIT_MODEL_STATUS.OPEN, AUDIT_MODEL_STATUS.DRAFT],
        ...params,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/global/generic.types').PageContent<import('modules/auditModels/types').AuditModel>} auditModels
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsAvailableSuccessAction}
 */
export const fetchAuditModelsAvailableSuccess = (auditModels, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_AVAILABLE_SUCCESS,
  payload: auditModels,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').FetchAuditModelsAvailableFailureAction}
 */
export const fetchAuditModelsAvailableFailure = (error, meta = {}) => ({
  type: types.FETCH_AUDIT_MODELS_AVAILABLE_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {string} auditModelId
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').SelectAuditModelAction}
 */
export const selectAuditModel = (auditModelId, meta = {}) => ({
  type: types.SELECT_AUDIT_MODEL,
  payload: auditModelId,
  meta,
});

/**
 * @param {string} id
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeleteAuditModelAction}
 */
export const deleteAuditModel = (id, auditModelId, meta = {}) => ({
  type: types.DELETE_AUDIT_MODEL,
  payload: {
    request: {
      method: 'DELETE',
      url: `${AUDIT_MODELS_API_URL}/${id}`,
    },
    auditModelId,
  },
  meta,
});

/**
 * @param {string} auditModelId
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeleteAuditModelSuccessAction}
 */
export const deleteAuditModelSuccess = (auditModelId, meta = {}) => ({
  type: types.DELETE_AUDIT_MODEL_SUCCESS,
  payload: auditModelId,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeleteAuditModelFailureAction}
 */
export const deleteAuditModelFailure = (message, meta = {}) => ({
  type: types.DELETE_AUDIT_MODEL_FAILURE,
  payload: message,
  error: true,
  meta,
});

/**
 *
 * @param {string} auditModelId
 * @param {string} dealerId
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeactivateAuditModelAction}
 */
export const deactivateAuditModel = (auditModelId, dealerId, meta) => ({
  type: types.DEACTIVATE_AUDIT_MODEL,
  payload: {
    request: {
      method: 'DELETE',
      url: `${AUDIT_MODELS_API_URL}/${auditModelId}/activeDealers/${dealerId}`,
    },
  },
  meta,
});

/**
 * @param {import('modules/auditModels/types').AuditModel} auditModel
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeactivateAuditModelSuccessAction}
 */
export const deactivateAuditModelSuccess = (auditModel, meta = {}) => ({
  type: types.DEACTIVATE_AUDIT_MODEL_SUCCESS,
  payload: auditModel,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').DeactivateAuditModelFailureAction}
 */
export const deactivateAuditModelFailure = (message, meta = {}) => ({
  type: types.DEACTIVATE_AUDIT_MODEL_FAILURE,
  payload: message,
  error: true,
  meta,
});

/**
 * @param {{ auditModelId: string } & import('modules/auditModels/types').ActivateAuditModelActionPayload} data
 * @param {Object} [meta={}]
 * @return {import('modules/auditModels/types').ActivateAuditModelAction}
 */
export const activateAuditModel = ({ auditModelId, dealerId, daysPerWeek, weeklyTarget }, meta = {}) => ({
  type: types.ACTIVATE_AUDIT_MODEL,
  payload: {
    request: {
      method: 'POST',
      url: `${AUDIT_MODELS_API_URL}/${auditModelId}/activeDealers`,
      data: {
        dealerId,
        daysPerWeek,
        weeklyTarget,
      },
    },
  },
  meta,
});

/**
 * @param {import('modules/auditModels/types').AuditModel} auditModel
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').ActivateAuditModelSuccessAction}
 */
export const activateAuditModelSuccess = (auditModel, meta = {}) => ({
  type: types.ACTIVATE_AUDIT_MODEL_SUCCESS,
  payload: auditModel,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').ActivateAuditModelFailureAction}
 */
export const activateAuditModelFailure = (message, meta = {}) => ({
  type: types.ACTIVATE_AUDIT_MODEL_FAILURE,
  payload: message,
  error: true,
  meta,
});
